// extracted by mini-css-extract-plugin
export default {"pWrapper":"Products_pWrapper__IfppV","productsContainer":"Products_productsContainer__JbhMM","searchInput":"Products_searchInput__ufLVA"};